import { createClient } from '@supabase/supabase-js';

// Reads from .env.local in development, Vercel environment variables in production
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://zvbikgbqnfrwojuljwbg.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp2YmlrZ2JxbmZyd29qdWxqd2JnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUzMzE1MjQsImV4cCI6MjA5MDkwNzUyNH0.gLwWVy8g6aIVbcswUZRe7L6gJvbZ9OyQALHe8GzkDzo';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);